<template>
    <div class="container">
        <div class="file-uploader">
            <div class="file-inputs">
                <file-upload multiple v-for="(file, index) in fileList"
                             :key="index" :index="parseInt( index )" @selected="selectFiles"
                             @remove="removeFile" :errors="uploadErrors" :name="name" :file="file"></file-upload>
                <file-upload multiple :name="name" :index="fileList.length"
                             @selected="selectFiles" :errors="uploadErrors" @remove="removeFile"></file-upload>
            </div>
        </div>
        <div class="field">
            <p class="has-text-danger">
                <small v-text="'* '+lang('Per la redazione del preventivo è necessario allegare la seguente documentazione: planimetria, sezione della copertura. In caso di mancato invio la richiesta non potrà essere presa in considerazione.')"></small>
            </p>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash'
    import FormErrors from "../Classes/FormErrors";

    export default {
        props: {
            value: {
                type: Array,
                required: false
            },
            errors: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                name: 'attachments[]',
                fileList: [],
                uploadErrors: new FormErrors()
            }
        },
        mounted() {
            if( typeof this.value === 'object' ) {
                this.fileList = this.value;
            }
        },
        methods: {
            selectFiles( files, index ) {
                if( files.length === 1 ) {
                    this.fileList.splice(index, 1, files[0]);
                } else {
                    for( let file of files ) {
                        this.fileList.push( file );
                    }
                }

                this.$emit('input', this.fileList)
            },
            removeFile( index ) {
                this.fileList.splice(index, 1);
            },
            isEmpty( value ) {
                return _.isEmpty( value );
            }
        },
        watch: {
            fileList: {
                handler() {
                  if(this.fileList.length > 0) {
                    this.$emit('completed')
                  }
                },
                deep: true
            },
            value( value ) {
                if( typeof value === 'object' ) {
                    this.fileList = value;
                }
            },
            errors( errors ) {
                if( errors.upload ) {
                    this.uploadErrors.record( errors.upload );
                }
            }
        }
    }
</script>